import filter from '@/state/modules/filter-store'
import edit from '@/state/modules/edit-store'
import notificationBus from '@/state/modules/notification-bus'
import user from '@/state/modules/user'
import jobs from '@/state/modules/jobs'
import profiles from '@/state/modules/profiles-store'
import expenseReports from '@/state/modules/expense-reports'
import tableBills from '@/state/modules/table-bills'
import conversation from '@/state/modules/conversation'
import navigation from '@/state/modules/navigation-store'

export default {
  modules: {
    filter,
    edit,
    notificationBus,
    user,
    jobs,
    profiles,
    expenseReports,
    tableBills,
    conversation,
    navigation,
  },
}
